var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header", attrs: { id: _vm.elementHeaderId } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-block unfocus text-center text-nowrap",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": `#${_vm.elementCollapseId}`,
              "aria-expanded": _vm.expanded,
              "aria-controls": _vm.elementCollapseId,
            },
          },
          [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        class: { show: _vm.expanded },
        attrs: {
          id: _vm.elementCollapseId,
          "aria-labelledby": _vm.elementHeaderId,
        },
      },
      [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(_vm.componentForm, {
              tag: "component",
              attrs: {
                panelCfg: _vm.panelCfg,
                baseTranslateID: _vm.baseTranslateID,
                labelDateFormat: _vm.labelDateFormat,
                dateFormat: _vm.dateFormat,
                readonlyForm: _vm.readonlyForm,
                vScope: _vm.vScope,
                lists: _vm.lists,
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }